
import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class NotificationToast {
    show = false;
    error = false;
    text = '';
    delay = 3000;

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);

        this.rootStore = rootStore;
    }

    showNotification(text: string,error: boolean, delay: number) {
        this.show = true;
        this.text = text;
        this.delay = delay;
        this.error = error;
      }

    resetNotification() {
    this.show = false;
    }

    handleShow = (a: boolean) =>  {
        this.show = a;
    }

    handleError = (isError: boolean) => {
        this.error = isError;
    }

    get getShow() {
        return this.show;
    }
    get getText() {
        return this.text;
    }
    get getError() {
        return this.error;
    }
}